<!-- <div id="canvas" class="gradient"></div>
<div id="global-loader" ><div class="showbox"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div></div> -->
<div class="page">
  <div class="page-content">
    <div class="container text-center">
      <div class="display-1  mb-5"> 500</div>
      <h1 class="h2  mb-3">Page Not Found</h1>
      <p class="h4 font-weight-normal mb-7 leading-normal">Oops!!!! you tried to access a page which is not available. go back to Home</p>
      <a class="btn btn-primary" href="index.html">
        Back To Home
      </a>
    </div>
  </div>
</div>